<template lang="pug">
  .container
    .columns.is-vcentered
      .column.is-3
        span.tag.is-black
          | {{ salida.nombre_usuario }}
      .column.is-3
        span.tag.is-black
          i.fas.fa-car
          | &nbsp{{ salida.categoriaV }} - {{ salida.subcategoriaV }} 
      .column.is-3
        span.tag.is-black
          i.far.fa-credit-card
          | &nbsp{{ salida.tarjeta }}
      .column.is-3
        label.label Fecha Salida:
        .field
          .control
            flat-pickr(
              v-model='fechaSalida'
              :config="config"
              class="input"
            )
    .columns.is-vcentered
      .column.is-3
        .field
          label.label Carga en Pesos
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='00.00',
                v-model="cargaP",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Carga en Litros
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='00.00',
                v-model="cargaL",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Km. Actual
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='00.00',
                v-model="kmActual",
                :disabled="isDisabled"
              )
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      a.button.is-warning.is-rounded(@click="checkForm")
        | Editar Salida
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  export default {
    name: 'FormEditar',
    components: { flatPickr },
    props: {
      salida: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        cargaP: null,
        cargaL: null,
        kmActual: null,
        isDisabled: false,
        datosFaltantes: [],
        fechaSalida: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
      }
    },
    methods: {
      iniciarComponente() {
        this.cargaP = this.salida.cargaPesos
        this.cargaL = this.salida.cargaLitros
        this.kmActual = this.salida.km_actual
        this.fechaSalida = this.salida.fecha_salida
      },
      checkForm() {
        this.datosFaltantes = []
        if (this.cargaP && this.cargaL && this.kmActual) {
          console.log('Datos completos')
          this.saveEditar()
        } else {
          console.log('Datos Incompletos')
          if (!this.cargaP) {
            this.datosFaltantes.push('La Carga en Pesos es necesario.')
          }
          if (!this.cargaL) {
            this.datosFaltantes.push('La Carga en Litros es necesario.')
          }
          if (!this.kmActual) {
            this.datosFaltantes.push('El Km. actual es necesario.')
          }
        }
      },
      saveEditar() {
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let myObj = {
          fechaSalida: this.fechaSalida,
          cargaP: this.cargaP,
          cargaL: this.cargaL,
          kmActual: this.kmActual
        }
        this.$emit('saveForm', myObj)
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormEditar.vue